import { ServerStatus } from './types';

export const initServers: ServerStatus[] = [
  { name: 'API Gateway', status: 'Hors ligne', color: 'red' },
  { name: 'API Mobile', status: 'Hors ligne', color: 'red' },
  { name: 'Mobile DataBase', status: 'Hors ligne', color: 'red' },
  { name: 'AMC DataBase', status: 'Hors ligne', color: 'red' },
  { name: 'API E-Commerce', status: 'Hors ligne', color: 'red' },
  { name: 'E-Commerce DataBase', status: 'Hors ligne', color: 'red' },
  { name: 'API SAGIS', status: 'Hors ligne', color: 'red' },
  { name: 'WebService OCP', status: 'Hors ligne', color: 'red' },
  { name: 'API Corporeal', status: 'Hors ligne', color: 'red' },
  { name: 'API Valeur Client', status: 'Hors ligne', color: 'red' },
  { name: 'Valeur Client DataBase', status: 'Hors ligne', color: 'red' },
  { name: 'API MyClient', status: 'Hors ligne', color: 'red' },
];
